<template>
  <div>
    <my-table
      :data="data"
      :loading="loading"
      :headers="headers"
      :query="query"
      @create="handleCreate"
      @edit="handleEdit"
      @delete="handleDelete"
      @search="handleSearch"
      @change-page="handleChangePage"
      @change-limit="handleChangeLimit"
      @refresh="handleRefresh"
    >
      <template v-slot:actions>
        <my-button @click="handleSms" type="primary" v-if="name === 'current'" icon="chat-alt-2">Mass sms!</my-button>
      </template>
    </my-table>
    <detail
      v-model:visible="visible"
      :id="id"
      :tableName="name"
      @saved="handleSaved"
    />
  </div>
</template>
<script>
import listMethods from '../../../utils/listMethods'
import listData from '../../../utils/listData'
import detail from './detail.vue'
export default {
  components: {
    detail
  },
  data () {
    return {
      ...listData,
      listApiUrl: '/lookups/list',
      visible: false,
      headers: [
        {
          name: 'code',
          caption: 'Код',
          width: '90px'
        },
        {
          name: 'name',
          caption: 'Нэр'
        },
        {
          name: 'createdBy.firstName',
          caption: 'Бүртгэсэн ажилтан',
          width: '100px'
        },
        {
          name: 'createdAt',
          caption: 'Бүртгэсэн огноо',
          width: '100px',
          type: 'Date'
        }
      ],
      id: null,
      query: { page: 1, limit: 15, sort: [], search: [] }
    }
  },
  computed: {
    name () {
      return this.$route.params.name
    }
  },
  watch: {
    name () {
      if (this.$route.name !== 'lookups') {
        return
      }
      this.handleRefresh()
    }
  },
  created () {
    this.handleRefresh()
  },
  methods: {
    ...listMethods,
    handleCreate () {
      this.id = null
      this.visible = true
    },
    handleEdit (id) {
      this.id = id
      this.visible = true
    },
    handleSaved (row) {
      const index = this.data[0].findIndex(c => c.id === row.id)
      if (index === -1) {
        this.data[0].unshift(row)
      } else {
        this.data[0].splice(index, 1, row)
      }
    },
    async handleDelete (id) {
      try {
        await this.showConfirm({ message: 'Та энэ үйлдлийг хийхдээ итгэлтэй байна уу?' })
        this.loading = true
        await this.axios.delete('lookups', {
          data: {
            tableName: this.name,
            id
          }
        })
        const index = this.data[0].findIndex(c => c.id === id)
        if (index !== -1) {
          this.data[0].splice(index, 1)
        }
        this.showToast('Амжилттай устгалаа.')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
